<template>
  <div class="container">
    <a v-if="social.instagram" :href="social.instagram" target="_blank">
      <img :src="baseUrl + '/instagram-48-pink.png'" alt="instagram" />
    </a>
    <a v-if="social.twitter" :href="social.twitter" target="_blank">
      <img :src="baseUrl + '/twitter-48-pink.png'" alt="twitter" />
    </a>
    <a v-if="social.telegram" :href="social.telegram" target="_blank">
      <img :src="baseUrl + '/telegram-48-pink.png'" alt="telegram" />
    </a>
  </div>
</template>

<script>
import ThemeManager from "../../modules/ThemeManager/ThemeManager.js";

export default {
  data() {
    const DIVAS_SOCIALS = {
      instagram: process.env.VUE_APP_SOCIAL_INSTAGRAM,
      twitter: process.env.VUE_APP_SOCIAL_TWITTER,
      telegram: process.env.VUE_APP_SOCIAL_TELEGRAM,
    };

    const CHADS_SOCIALS = {
      instagram: process.env.VUE_APP_SOCIAL_INSTAGRAM_CHADS,
      twitter: process.env.VUE_APP_SOCIAL_TWITTER_CHADS,
      telegram: process.env.VUE_APP_SOCIAL_TELEGRAM_CHADS,
    };

    const social = ThemeManager.isChadsTheme() ? CHADS_SOCIALS : DIVAS_SOCIALS;

    return {
      social,
      divasSocials: DIVAS_SOCIALS,
      chadsSocials: CHADS_SOCIALS,
    };
  },
  computed: {
    baseUrl() {
      let url = '/img';

      if (ThemeManager.isChadsTheme()) {
        url += '/themes/chads';
      }

      return url + '/socials';
    },
  },
  watch: {
    '$store.state.general.site_type': function(value) {
      this.social = value === 'chads' ? this.chadsSocials : this.divasSocials;
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../styles/variables";

.container {
  display: flex;

  a {
    display: flex;
    align-items: center;
    font-size: 0.8em;
    //margin-bottom: 5px;
    font-weight: bold;

    &:hover {
      color: #ccc;
    }

    @media (max-width: 900px) {
      justify-content: center;
    }

    img {
      width: 38px;

      @media (max-width: 768px) {
        width: 30px;
      }
    }

    &:not(:last-of-type) img {
      margin-right: 0.5em;
    }
  }
}
</style>
